module.exports = __webpack_public_path__ + "static/result-410cf4f5a1aaa43047f13b6958ec8ab0.svg";